import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, inject, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'app-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss']
})
export class SelectInputComponent implements AfterViewInit, OnChanges {

  private loadingService = inject(LoadingService);
  loading$ = this.loadingService.loading$;

  @Input() list!: { name: string, value: string }[];
  @Input() required = false;
  @Input() label = '';
  @Input() initialValue = '';
  @Input() placeholder = '';
  @Input() disabled = false;
  @Input() loadMoreButton = false;
  @Input() cleanFilterButton = true;
  @Input() change = false;
  @Input() positionRelative = false;

  @Output() changeValue = new EventEmitter();
  @Output() loadMore = new EventEmitter();
  @Output() getSearchOptions = new EventEmitter();
  @Output() enterPressed = new EventEmitter<string>();
  @Output() cleanFilter = new EventEmitter<string>();

  optionsSelected: any = null;
  searchWord = '';

  value = '';
  optionsShow = false;
  optionsList: { name: string, value: string }[] = [];
  changeInput = true;

  @ViewChild('optionsListElement') optionsListElement!: ElementRef;
  page = 0;

  constructor(private elementRef: ElementRef) {
    this.optionsList = this.list;
  }

  onEnter(event: any) {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();
    this.enterPressed.emit(this.value);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.initialValue) {
      this.value = this.initialValue;
    }
    if (changes['list'] && changes['list'].currentValue) {
      this.optionsList = changes['list'].currentValue;
    }
  }

  ngAfterViewInit(): void {
    this.optionsList = this.list;
  }

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      if (this.optionsShow) {
        this.toggleOptions();
      }
    }
  }

  toggleOptions() {
    this.optionsShow = !this.optionsShow;
  }

  openOptions() {
    this.toggleOptions();
    this.change = true;
  }

  changeOptionsFilter(optionsList: any) {
    this.optionsList = optionsList;
  }

  valueIsValid(): boolean {
    // && this.optionsList.some(item => item.name === this.value)
    return this.value !== '';
  }

  filterList(event: any) {
    this.optionsShow = true;
    if (event.type === 'change') {
      this.changeInput = true;
    }
    if (event.code === 'Enter' && this.changeInput) {
      this.searchWord = this.value;
      this.page = 0;
      this.getSearchOptions.emit(this.searchWord);
      this.changeInput = false;
    }

    if (event.target.value === '') {
      this.changeValue.emit('');
    }

    if (event.type === 'focus' && this.changeInput) {
      this.searchWord = this.value;
      this.page = 0;
      this.getSearchOptions.emit(this.searchWord);
      this.changeInput = false;
    }
  }

  selectOption(option: { name: string, value: string }) {
    if (option.value == '') {
      this.cleanFilter.emit();
    }
    this.value = option.name;
    this.optionsSelected = option;
    this.changeValue.emit(this.optionsSelected);
    this.optionsShow = false;
  }

  loadMoreOptions() {
    this.value = this.searchWord;
    this.loadMore.emit(this.page);
    const children = this.optionsListElement.nativeElement.children;
    if (children.length >= 10) {
      const antepenultimateChild = children[children.length - 10];
      antepenultimateChild.scrollIntoView({ behavior: 'smooth' });
    }
  }

  setValue(value: string) {
    this.value = value;
  }
}
